import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../../../redux/store';
import Editor from './Editor';

const EditorWrapper = ({ id, preview }) => {
    return (
        <>
            <Provider store={store}>
                <Editor id={id} preview={preview} />
            </Provider>
        </>
    );
};

export default EditorWrapper;
